import React from "react";

import { OrderReleaseOrdersContextProvider } from "./context/order-release-orders-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class OrdersReleaseOrdersPage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <OrderReleaseOrdersContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </OrderReleaseOrdersContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default OrdersReleaseOrdersPage;
